export function randomizeShaderOutput(seed: number): string {
  const simpleSeededRandom = function () {
    seed = (Math.imul(seed, 1664525) + 1013904223) % 4294967295;
    return Math.abs(seed);
  };

  // Randomize the shader to force a cold load bypassing shader caches the browser and GPU driver might have.
  const randomString = simpleSeededRandom().toString(36);
  const mul = Math.pow(2, -36);
  const randomValue = [
    simpleSeededRandom() * mul,
    simpleSeededRandom() * mul,
    simpleSeededRandom() * mul,
    simpleSeededRandom() * mul,
  ];
  return `const vec4 noise${randomString} = vec4(${randomValue[0]}, ${randomValue[1]}, ${randomValue[2]}, ${randomValue[3]});
      gl_FragColor = gl_FragColor + noise${randomString};
      `;
}
